import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { flow, observable, runInAction } from "mobx";
import { routeLocationAffiliateCouponDelete } from "@devowl-wp/api-real-commerce";
import { RealCommerceError } from "../exceptions/realCommerceError.js";
import { realCommerceRequest } from "../utils/realCommerceRequest.js";
class AffiliateCoupon {
    get session() {
        return this.store.store;
    }
    constructor(data, store){
        this.busy = false;
        this.delete = flow(function*() {
            this.busy = true;
            yield this.session.probablyRenewJwt();
            try {
                const { data: { id } } = this;
                yield realCommerceRequest({
                    location: routeLocationAffiliateCouponDelete,
                    request: {
                        coupon: {
                            id
                        }
                    },
                    settings: {
                        headers: this.session.authorizationHeader
                    }
                });
                yield this.store.fetchCoupons();
            } catch (e) {
                console.log(e);
                throw new RealCommerceError(e);
            } finally{
                this.busy = false;
            }
        });
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], AffiliateCoupon.prototype, "data", void 0);
_ts_decorate([
    observable
], AffiliateCoupon.prototype, "busy", void 0);
export { AffiliateCoupon };
